import script from "./SubmitAuthenticatorDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubmitAuthenticatorDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SubmitAuthenticatorDialog.vue?vue&type=style&index=0&id=6466f86f&scoped=true&lang=css"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6466f86f"]])

export default __exports__